'use strict';
const AuthenticationModel = require('../../models/authentication-model'),
	CrowdlinkAuthenticator = require('../../models/crowdlink-authenticator');

module.exports = function authenticationCrowdlinkStart({goldApi, context}) {
	if (!goldApi || !context) {
		throw new Error('invalid-args');
	}
	const authenticationModel = new AuthenticationModel(),
		crowdlinkAuthenticator = new CrowdlinkAuthenticator({goldApi, authenticationModel, context});
	return {authenticationModel, crowdlinkAuthenticator};
};
